import { render, staticRenderFns } from "./BasicLayoutday.vue?vue&type=template&id=f60f53be&scoped=true"
import script from "./BasicLayoutday.vue?vue&type=script&lang=js"
export * from "./BasicLayoutday.vue?vue&type=script&lang=js"
import style0 from "./BasicLayoutday.vue?vue&type=style&index=0&id=f60f53be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60f53be",
  null
  
)

export default component.exports